import memoize from 'lodash/memoize';

const getEnvironment = memoize(() => {
  let ENV = 'prod';
  const { origin } = window.location;
  if (origin.includes('dev')) ENV = 'beta';
  else if (origin.includes('qa')) ENV = 'gamma';
  return ENV;
});

export const isLocalEnv = memoize(() => origin.includes('local'));

export default getEnvironment;
